import { screen, breakpoints } from './grid';
import { palette } from './palette';
import { spacer, spacers } from './spacers';

export const theme = {
  spacer,
  spacers,
  palette,
  screen,
  breakpoints,
};
